module.exports = __webpack_public_path__ + "static/media/Cluster-6_2000.e0630a57.jpg";